import styled from "styled-components";
import { BodyDefault } from "../../typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 10px 20px;
  box-sizing: border-box;
  width: 400px;
  left: 540px;
  background: ${({theme}) => theme.palette[10]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
`

export const BodyModal = styled.div`
  flex-direction: column;
  align-items: center;
  padding: 0px 10px;
  width: 100%;
  box-sizing: border-box;
`

export const Icon = styled.img`
  &:hover{
    cursor: pointer;
  }
`

export const Divider = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.palette[20]}`};
  width: 100%;
  margin-top: 20px;
  margin-bottom: 24px;
`

export const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  background: ${({theme}) => theme.palette[200]};
  border-radius: 4px;
  &:hover{
    cursor: pointer;
  }
`

export const RolesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`
